export default {
  "vueform": {
    "elements": {
      "list": {
        "add": "+ 添加",
        "remove": "&times;"
      },
      "file": {
        "defaultName": "文件",
        "dndTitle": "上传文件",
        "dndDescription": "拖放文件或点击此处上传",
        "removeConfirm": "通过删除文件，它将被永久删除。 你确定要继续吗？",
        "select": "选择文件",
        "upload": "上传"
      },
      "multifile": {
        "uploadButton": "上传文件",
        "dndTitle": "上传文件",
        "dndDescription": "删除文件或单击此处上传"
      },
      "gallery": {
        "uploadButton": "上传图片",
        "dndTitle": "上传图片",
        "dndDescription": "删除图片或点击此处上传"
      },
      "phone": {
        "ariaLabel": "选择一个国家"
      },
      "signature": {
        "type": "打字",
        "draw": "绘制",
        "upload": "上传",
        "font": "选择字体",
        "fontPlaceholder": "您的名字",
        "placeholder": "在此签名",
        "unsupportedFormat": "不支持的文件格式。接受的扩展名是：:extensions",
        "maxSizeError": "最大文件大小为 :max KB",
        "imgAlt": "签名",
        "imgTitle": "签名",
        "undo": "撤销",
        "redo": "重做",
        "dnd": "将图像拖放到此处或",
        "uploadButton": "选择图像",
        "modeSelectorAriaLabel": "选择签名模式",
        "fontSelectorAriaLabel": "选择字体",
        "wrapperAriaLabel": "签名输入",
        "inputAriaLabel": "在此输入您的签名",
        "padAriaLabel": "在框中绘制您的签名。如需帮助，请寻求协助。",
        "clearAriaLabel": "清除签名",
        "colorAriaLabel": "选择颜色："
      }
    },
    "steps": {
      "finish": "结束",
      "next": "下一个",
      "previous": "以前的"
    },
    "editor": {
      "acceptedMimesError": "接受的哑剧是：:mimes",
      "acceptedExtensionsError": "接受的扩展是：:extensions"
    },
    "datepicker": {
      "weekdays": {
        "shorthand": [
          "周日",
          "周一",
          "周二",
          "周三",
          "周四",
          "周五",
          "周六"
        ],
        "longhand": [
          "星期日",
          "星期一",
          "星期二",
          "星期三",
          "星期四",
          "星期五",
          "星期六"
        ]
      },
      "months": {
        "shorthand": [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月"
        ],
        "longhand": [
          "一月",
          "二月",
          "三月",
          "四月",
          "五月",
          "六月",
          "七月",
          "八月",
          "九月",
          "十月",
          "十一月",
          "十二月"
        ]
      },
      "daysInMonth": [
        31,
        28,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
      ],
      "firstDayOfWeek": 0,
      "ordinal": function () {
        return '';
      },
      "rangeSeparator": " 至 ",
      "weekAbbreviation": "周",
      "scrollTitle": "滚动切换",
      "toggleTitle": "点击切换 12/24 小时时制",
      "amPM": [
        "AM",
        "PM"
      ],
      "yearAriaLabel": "Year",
      "monthAriaLabel": "Month",
      "hourAriaLabel": "Hour",
      "minuteAriaLabel": "Minute"
    },
    "dateFormats": {
      "datetimeSeconds24": "DD/MM/YYYY, HH:mm:ss",
      "datetimeSeconds12": "DD/MM/YYYY, hh:mm:ss a",
      "datetime24": "DD/MM/YYYY, HH:mm",
      "datetime12": "DD/MM/YYYY, hh:mm a",
      "timeSeconds24": "HH:mm:ss",
      "timeSeconds12": "hh:mm:ss a",
      "time24": "HH:mm",
      "time12": "hh:mm a",
      "date": "DD/MM/YYYY"
    },
    "multiselect": {
      "multipleLabelOne": "已选择 1 个选项",
      "multipleLabelMore": ":options 选项已选择",
      "noResults": "未找到选项",
      "noOptions": "列表为空"
    },
    "defaultMessage": "无效字段",
    "a11y": {
      "file": {
        "description": "Press Backspace to remove"
      },
      "list": {
        "remove": "Remove item button"
      }
    },
    "countries": {
      "AF": "阿富汗",
      "AL": "阿尔巴尼亚",
      "DZ": "阿尔及利亚",
      "AS": "美属萨摩亚",
      "AD": "安道尔",
      "AO": "安哥拉",
      "AI": "安圭拉",
      "AG": "安提瓜和巴布达",
      "AR": "阿根廷",
      "AM": "亚美尼亚",
      "AW": "阿鲁巴",
      "AC": "阿森松岛",
      "AU": "澳大利亚",
      "AT": "奥地利",
      "AZ": "阿塞拜疆",
      "BS": "巴哈马",
      "BH": "巴林",
      "BD": "孟加拉国",
      "BB": "巴巴多斯",
      "BY": "白俄罗斯",
      "BE": "比利时",
      "BZ": "伯利兹",
      "BJ": "贝宁",
      "BM": "百慕大",
      "BT": "不丹",
      "BO": "玻利维亚",
      "BA": "波黑",
      "BW": "博茨瓦纳",
      "BR": "巴西",
      "IO": "英属印度洋领地",
      "VG": "英属维尔京群岛",
      "BN": "文莱",
      "BG": "保加利亚",
      "BF": "布基纳法索",
      "BI": "布隆迪",
      "KH": "柬埔寨",
      "CM": "喀麦隆",
      "CA": "加拿大",
      "CV": "佛得角",
      "BQ": "荷兰加勒比区",
      "KY": "开曼群岛",
      "CF": "中非共和国",
      "TD": "乍得",
      "CL": "智利",
      "CN": "中国",
      "CO": "哥伦比亚",
      "KM": "科摩罗",
      "CG": "刚果（布）",
      "CD": "刚果（金）",
      "CK": "库克群岛",
      "CR": "哥斯达黎加",
      "CI": "科特迪瓦",
      "HR": "克罗地亚",
      "CU": "古巴",
      "CW": "库拉索",
      "CY": "塞浦路斯",
      "CZ": "捷克",
      "DK": "丹麦",
      "DJ": "吉布提",
      "DM": "多米尼克",
      "DO": "多米尼加",
      "EC": "厄瓜多尔",
      "EG": "埃及",
      "SV": "萨尔瓦多",
      "GQ": "赤道几内亚",
      "ER": "厄立特里亚",
      "EE": "爱沙尼亚",
      "SZ": "斯威士兰",
      "ET": "埃塞俄比亚",
      "FK": "福克兰群岛",
      "FO": "法罗群岛",
      "FJ": "斐济",
      "FI": "芬兰",
      "FR": "法国",
      "GF": "法属圭亚那",
      "PF": "法属波利尼西亚",
      "GA": "加蓬",
      "GM": "冈比亚",
      "GE": "格鲁吉亚",
      "DE": "德国",
      "GH": "加纳",
      "GI": "直布罗陀",
      "GR": "希腊",
      "GL": "格陵兰",
      "GD": "格林纳达",
      "GP": "瓜德罗普",
      "GU": "关岛",
      "GT": "危地马拉",
      "GN": "几内亚",
      "GW": "几内亚比绍",
      "GY": "圭亚那",
      "HT": "海地",
      "HN": "洪都拉斯",
      "HK": "中国香港",
      "HU": "匈牙利",
      "IS": "冰岛",
      "IN": "印度",
      "ID": "印度尼西亚",
      "IR": "伊朗",
      "IQ": "伊拉克",
      "IE": "爱尔兰",
      "IL": "以色列",
      "IT": "意大利",
      "JM": "牙买加",
      "JP": "日本",
      "JO": "约旦",
      "KZ": "哈萨克斯坦",
      "KE": "肯尼亚",
      "KI": "基里巴斯",
      "XK": "科索沃",
      "KW": "科威特",
      "KG": "吉尔吉斯斯坦",
      "LA": "老挝",
      "LV": "拉脱维亚",
      "LB": "黎巴嫩",
      "LS": "莱索托",
      "LR": "利比里亚",
      "LY": "利比亚",
      "LI": "列支敦士登",
      "LT": "立陶宛",
      "LU": "卢森堡",
      "MO": "中国澳门",
      "MG": "马达加斯加",
      "MW": "马拉维",
      "MY": "马来西亚",
      "MV": "马尔代夫",
      "ML": "马里",
      "MT": "马耳他",
      "MH": "马绍尔群岛",
      "MQ": "马提尼克",
      "MR": "毛里塔尼亚",
      "MU": "毛里求斯",
      "MX": "墨西哥",
      "FM": "密克罗尼西亚",
      "MD": "摩尔多瓦",
      "MC": "摩纳哥",
      "MN": "蒙古",
      "ME": "黑山",
      "MS": "蒙特塞拉特",
      "MA": "摩洛哥",
      "MZ": "莫桑比克",
      "MM": "缅甸",
      "NA": "纳米比亚",
      "NR": "瑙鲁",
      "NP": "尼泊尔",
      "NL": "荷兰",
      "NC": "新喀里多尼亚",
      "NZ": "新西兰",
      "NI": "尼加拉瓜",
      "NE": "尼日尔",
      "NG": "尼日利亚",
      "NU": "纽埃",
      "NF": "诺福克岛",
      "KP": "朝鲜",
      "MK": "北马其顿",
      "MP": "北马里亚纳群岛",
      "NO": "挪威",
      "OM": "阿曼",
      "PK": "巴基斯坦",
      "PW": "帕劳",
      "PS": "巴勒斯坦",
      "PA": "巴拿马",
      "PG": "巴布亚新几内亚",
      "PY": "巴拉圭",
      "PE": "秘鲁",
      "PH": "菲律宾",
      "PL": "波兰",
      "PT": "葡萄牙",
      "PR": "波多黎各",
      "QA": "卡塔尔",
      "RE": "留尼汪",
      "RO": "罗马尼亚",
      "RU": "俄罗斯",
      "RW": "卢旺达",
      "WS": "萨摩亚",
      "SM": "圣马力诺",
      "ST": "圣多美和普林西比",
      "SA": "沙特阿拉伯",
      "SN": "塞内加尔",
      "RS": "塞尔维亚",
      "SC": "塞舌尔",
      "SL": "塞拉利昂",
      "SG": "新加坡",
      "SX": "圣马丁（荷兰部分）",
      "SK": "斯洛伐克",
      "SI": "斯洛文尼亚",
      "SB": "所罗门群岛",
      "SO": "索马里",
      "ZA": "南非",
      "KR": "韩国",
      "SS": "南苏丹",
      "ES": "西班牙",
      "LK": "斯里兰卡",
      "BL": "圣巴泰勒米",
      "SH": "圣赫勒拿",
      "KN": "圣基茨和尼维斯",
      "LC": "圣卢西亚",
      "MF": "圣马丁（法国部分）",
      "PM": "圣皮埃尔和密克隆群岛",
      "VC": "圣文森特和格林纳丁斯",
      "SD": "苏丹",
      "SR": "苏里南",
      "SE": "瑞典",
      "CH": "瑞士",
      "SY": "叙利亚",
      "TW": "中国台湾",
      "TJ": "塔吉克斯坦",
      "TZ": "坦桑尼亚",
      "TH": "泰国",
      "TL": "东帝汶",
      "TG": "多哥",
      "TK": "托克劳",
      "TO": "汤加",
      "TT": "特立尼达和多巴哥",
      "TN": "突尼斯",
      "TR": "土耳其",
      "TM": "土库曼斯坦",
      "TC": "特克斯和凯科斯群岛",
      "TV": "图瓦卢",
      "VI": "美属维尔京群岛",
      "UG": "乌干达",
      "UA": "乌克兰",
      "AE": "阿联酋",
      "GB": "英国",
      "US": "美国",
      "UY": "乌拉圭",
      "UZ": "乌兹别克斯坦",
      "VU": "瓦努阿图",
      "VA": "梵蒂冈",
      "VE": "委内瑞拉",
      "VN": "越南",
      "WF": "瓦利斯和富图纳",
      "YE": "也门",
      "ZM": "赞比亚",
      "ZW": "津巴布韦"
    }
  },
  "validation": {
    "accepted": "您必须接受 :attribute。",
    "active_url": ":attribute 不是一个有效的网址。",
    "after": ":attribute 必须要晚于 :date。",
    "after_or_equal": ":attribute 必须要等于 :date 或更晚。",
    "alpha": ":attribute 只能由字母组成。",
    "alpha_dash": ":attribute 只能由字母、数字、短划线(-)和下划线(_)组成。",
    "alpha_num": ":attribute 只能由字母和数字组成。",
    "array": ":attribute 必须是一个数组。",
    "before": ":attribute 必须要早于 :date。",
    "before_or_equal": ":attribute 必须要等于 :date 或更早。",
    "between": {
      "numeric": ":attribute 必须介于 :min - :max 之间。",
      "file": ":attribute 必须介于 :min - :max KB 之间。",
      "string": ":attribute 必须介于 :min - :max 个字符之间。",
      "array": ":attribute 必须只有 :min - :max 个单元。"
    },
    "boolean": ":attribute 必须为布尔值。",
    "captcha": "Please verify that you are not a robot.",
    "completed": "Please fill in a valid phone number.",
    "confirmed": ":attribute 两次输入不一致。",
    "date": ":attribute 不是一个有效的日期。",
    "date_format": ":attribute 的格式必须为 :format。",
    "date_equals": ":attribute 必须要等于 :date。",
    "different": ":attribute 和 :other 必须不同。",
    "digits": ":attribute 必须是 :digits 位数字。",
    "digits_between": ":attribute 必须是介于 :min 和 :max 位的数字。",
    "dimensions": ":attribute 图片尺寸不正确。",
    "distinct": ":attribute 已经存在。",
    "email": ":attribute 不是一个合法的邮箱。",
    "exists": ":attribute 不存在。",
    "file": ":attribute 必须是文件。",
    "filled": ":attribute 不能为空。",
    "gt": {
      "numeric": ":attribute 必须大于 :value。",
      "file": ":attribute 必须大于 :value KB。",
      "string": ":attribute 必须多于 :value 个字符。",
      "array": ":attribute 必须多于 :value 个元素。"
    },
    "gte": {
      "numeric": ":attribute 必须大于或等于 :value。",
      "file": ":attribute 必须大于或等于 :value KB。",
      "string": ":attribute 必须多于或等于 :value 个字符。",
      "array": ":attribute 必须多于或等于 :value 个元素。"
    },
    "image": ":attribute 必须是图片。",
    "in": "已选的属性 :attribute 无效。",
    "in_array": ":attribute 必须在 :other 中。",
    "integer": ":attribute 必须是整数。",
    "ip": ":attribute 必须是有效的 IP 地址。",
    "ipv4": ":attribute 必须是有效的 IPv4 地址。",
    "ipv6": ":attribute 必须是有效的 IPv6 地址。",
    "json": ":attribute 必须是正确的 JSON 格式。",
    "lt": {
      "numeric": ":attribute 必须小于 :value。",
      "file": ":attribute 必须小于 :value KB。",
      "string": ":attribute 必须少于 :value 个字符。",
      "array": ":attribute 必须少于 :value 个元素。"
    },
    "lte": {
      "numeric": ":attribute 必须小于或等于 :value。",
      "file": ":attribute 必须小于或等于 :value KB。",
      "string": ":attribute 必须少于或等于 :value 个字符。",
      "array": ":attribute 必须少于或等于 :value 个元素。"
    },
    "max": {
      "numeric": ":attribute 不能大于 :max。",
      "file": ":attribute 不能大于 :max KB。",
      "string": ":attribute 不能大于 :max 个字符。",
      "array": ":attribute 最多只有 :max 个单元。"
    },
    "mimes": ":attribute 必须是一个 :values 类型的文件。",
    "mimetypes": ":attribute 必须是一个 :values 类型的文件。",
    "min": {
      "numeric": ":attribute 必须大于等于 :min。",
      "file": ":attribute 大小不能小于 :min KB。",
      "string": ":attribute 至少为 :min 个字符。",
      "array": ":attribute 至少有 :min 个单元。"
    },
    "not_in": "已选的属性 :attribute 非法。",
    "not_regex": ":attribute 的格式错误。",
    "numeric": ":attribute 必须是一个数字。",
    "present": "The :attribute field must be present.",
    "regex": ":attribute 格式不正确。",
    "required": ":attribute 不能为空。",
    "required_if": "The :attribute field is required when :other is :value.",
    "required_unless": "The :attribute field is required unless :other is in :values.",
    "required_with": "The :attribute field is required when :values is present.",
    "required_with_all": "The :attribute field is required when :values are present.",
    "required_without": "The :attribute field is required when :values is not present.",
    "required_without_all": "The :attribute field is required when none of :values are present.",
    "same": ":attribute 和 :other 必须相同。",
    "size": {
      "numeric": ":attribute 大小必须为 :size。",
      "file": ":attribute 大小必须为 :size KB。",
      "string": ":attribute 必须是 :size 个字符。",
      "array": ":attribute 必须为 :size 个单元。"
    },
    "string": ":attribute 必须是一个字符串。",
    "timezone": ":attribute 必须是一个合法的时区值。",
    "unique": ":attribute 已经存在。",
    "uploaded": "The :attribute failed to upload.",
    "url": ":attribute 格式不正确。",
    "uuid": ":attribute 必须是有效的 UUID。",
    "remote": "The :attribute field is invalid."
  }
}